import React from 'react'

/**
 * Ponteiro de três pontos (›) usado nos botões do sistema de agência. Desenho próprio.
 * Herda `currentColor`.
 */
export function SetaPontos({ size = 16, className }: { size?: number; className?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <circle cx="9" cy="7" r="1.9" fill="currentColor" />
      <circle cx="9" cy="17" r="1.9" fill="currentColor" />
      <circle cx="15" cy="12" r="1.9" fill="currentColor" />
    </svg>
  )
}
